import { FormPageState } from 'types/formPage';

const initialState: FormPageState = {
  data: {},
  loadingId: '',
  isInitLoading : true,
  isError: false,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  error: ''
};

export default initialState;
